export type RecoBlockIdTypes =
  | 'home-page'
  | 'home-page-tabs'
  | 'cart-page'
  | 'product-page'
  | 'cross-sell'
  | 'cross-sell-feedback';

export type LoadRecommendationsHomemadeType =
  | { type: 'home'; params: {} }
  | {
      type: 'product';
      params: { productRef: string; colorRef: string };
    }
  | { type: 'cart'; params: { amount: number; products: string[] } };

export enum RecommendationEventTypes {
  upSell = 'up-sell',
  upSellTabs = 'up-sell-tabs',
  crossSell = 'cross-sell',
  crossSellFeedback = 'cross-sell-feedback',
}
